import React, { useEffect, useState } from "react";
import CreateAccountForm from "./CreateAccountForm/CreateAccountForm";
import LoginForm from "./LoginForm/LoginForm";
import './Login.css'
import Logo from "../../../Resources/Logo/LogoBordered.png"
import ForgotPasswordForm from "./ForgotPasswordForm/ForgotPasswordForm";

import Image1 from '../../../Resources/Images/Image1.png';
import Image2 from '../../../Resources/Images/Image2.png';
import Image3 from '../../../Resources/Images/Image3.png';
import Image4 from '../../../Resources/Images/Image4.png';
import Image5 from '../../../Resources/Images/Image5.png';
import Image6 from '../../../Resources/Images/Image6.png';

function Login({setIsParent, setUserID}) {

  const [showLogin, setShowLogin] = useState(true);
  
  const [forgotPassword, setForgotPassword] = useState(false);
  const [imgIndex, setImgIndex] = useState(0);
  const [fade, setFade] = useState(true);


  // const imgArray = [
  //   {name: 'NYC', img: 'https://schooltour.ie/wp-content/uploads/2016/10/nyshutterstock_575711801.jpg'},
  //   {name: 'LDN', img: 'https://schooltour.ie/wp-content/uploads/2016/10/london-shutterstock_674883131.jpg'},
  //   {name: 'RYK', img: 'https://schooltour.ie/wp-content/uploads/2019/08/Reykjavik-4.jpg'},
  //   {name: 'WSW', img: 'https://schooltour.ie/wp-content/uploads/2019/08/warsaw-1.jpg'},
  //   {name: 'KRW', img: 'https://schooltour.ie/wp-content/uploads/2016/10/krakow-shutterstock_808708001.jpg'},
  //   {name: 'RME', img: 'https://schooltour.ie/wp-content/uploads/2016/10/rome-shutterstock_657247961.jpg'},
  //   {name: 'RNL', img: 'https://schooltour.ie/wp-content/uploads/2016/10/rheinland-shutterstock_511178921.jpg'},
  //   {name: 'PRS', img: 'https://schooltour.ie/wp-content/uploads/2016/10/paris-shutterstock_473385371.jpg'},
  // ]

  const imgArray = [
    {name: 'Rome', text: "Inspiring learning beyond the classroom", img: Image1},
    {name: 'Berlin', text: "Explore Berlin’s history, culture and significance", img: Image2},
    {name: 'Sport', text: "We organise school sports tours too!", img: Image3},
    {name: 'Barcelona', text: "Discover the energy of sunny Barcelona", img: Image4},
    {name: 'NYC', text: "Experience the sights and sounds of New York City", img: Image5},
    {name: 'Ski', text: "We are trusted ski tour specialists", img: Image6}
  ]

  // useEffect(() => {
  //     const interval = setInterval(() => {
  //       setFade(false)
  //       setTimeout(() => {
  //         setImgIndex(prevIndex => (prevIndex + 1) % imgArray.length);
  //         setFade(true);
  //       },800);
        

  //     }, 5000);
      
  //     return () => clearInterval(interval);
  // }, [imgArray.length]);


  useEffect(() => {
    let timeout;

    const runCycle = () => {
      // Start fade out
      setFade(false);

      timeout = setTimeout(() => {
        // Change image after fade-out
        setImgIndex(prev => (prev + 1) % imgArray.length);

        // Fade back in
        setFade(true);

        // Wait before starting next cycle
        timeout = setTimeout(runCycle, 4600); // visible time
      }, 400); // fade duration
    };

    // Initial delay before first transition
    timeout = setTimeout(runCycle, 5000);

    return () => clearTimeout(timeout);
    }, [imgArray.length]);
  


  
  return (
    <div className="login-container">
      <div className="coloured-box-container">
        <div className='coloured-box'>

        <img className={`fade-image ${fade ? 'fade-in' : 'fade-out'} top-right-logo`} 
          src={Logo}
        />
         
          <img 
            className={`fade-image ${fade ? 'fade-in' : 'fade-out'}`}  
            src={imgArray[imgIndex].img} 
            alt={imgArray[imgIndex].name} 
          />

          <div className={`text-overlay ${fade ? 'fade-in' : 'fade-out'}`}>
            {imgArray[imgIndex].text}
          </div>
        </div>
      </div>


      <div className='login-form-container'>
        
        <div className='login-form-card'>
          <div style={{display:"flex", justifyContent: "center", alignItems: "center"}}>
          <img src={Logo} alt="LogoBordered" className="LogoBordered" />
          </div>

          {forgotPassword ? 

          <div>
            <ForgotPasswordForm setForgotPassword={setForgotPassword} />
          </div>

          : 
          <>
            <div className='login-options-display'>
              <div onClick={()=>setShowLogin(true)} className={showLogin ? 'active' : ""}>Login</div>
              <div onClick={()=>setShowLogin(false)} className={!showLogin ?'active' : ""}>Create Account</div>
            </div>
            {
              showLogin ? 
              <LoginForm setIsParent={setIsParent} setForgotPassword={setForgotPassword} />
              :
              <CreateAccountForm />
            }

          </>
          }
        </div>
          
                

      </div>
    </div>
  );
}

export default Login;
